import React  from 'react';

import {APPLICATIONS as Apps} from "utils/Applications";
import ApplicationButton from "../ApplicationButton";

function EikowItem(props) {
    return (
        <ApplicationButton
            application={Apps.EIKOW}
            selected={false}
            onClick={() => {
                if (['preprod', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT)) {
                    window.open('https://stock-easy-preprod.wishibam.dev/')
                } else {
                    window.open('https://app.eikow.com/login')
                }
            }}
        />
    );
}

export default EikowItem;
